module.exports = __webpack_public_path__ + "img/combination_symbols.50d91df.jpg";